import path from 'path-browserify';

export default function buildUrl(...parts: string[]) {
  return path.join(...parts);
}
